<template>
  <div class="offer-wrap">
    <div class="row mb-3"
         v-if="errors.any()"
    >
      <div class="col">
        <error-field v-if="errors.has('move_date')" :errors="errors" field="move_date"
                     class="pb-2 text-danger"
        />
        <error-field v-if="errors.has('arrival_window_id')" :errors="errors" field="arrival_window_id"
                     class="pb-2 text-danger"
        />
        <error-field v-if="errors.has('move_size_id')" :errors="errors" field="move_size_id"
                     class="pb-2 text-danger"
        />
        <error-field v-if="errors.has('mover_number')" :errors="errors" field="mover_number"
                     class="pb-2 text-danger"
        />
      </div>
    </div>
    <div class="row smaller mt-5">
      <div class="col">
        <div class="card-deck fixed-rate"
             v-if="data.company.fixed_rate"
        >
          <div class="card"
               v-for="(date, indexDate) in offers"
               :key="indexDate + 'e'"
          >
            <div class="mb-2 card-date">
              <div class="mod-icon-dark mod-icon-rates-dark" />
              {{ date.move_date }}
            </div>
            <div class="card-rate-info">
              <div class="row">
                <div class="col available-info border-right text-center p-1">
                  <div class="mod-icon-dark mod-icon-trucks-dark" />
                  {{ date.available_trucks }}
                  <span v-if="date.reserved_trucks" class="text-danger">({{ date.reserved_trucks }})</span>
                </div>
                <div class="col available-info text-center p-1">
                  <div class="mod-icon-dark mod-icon-groups-dark" />
                  {{ date.available_movers }}
                  <span v-if="date.reserved_movers" class="text-danger">({{ date.reserved_movers }})</span>
                </div>
              </div>
              <div v-for="(off, indexOffer) in date.offers"
                   :key="indexOffer + 'r'"
                   class="m-card-offer pointer"
                   :class="{'m-card-offer--selected': off.offered}"
                   @mouseover="off.bookCheck = off.offered && true && bookingPhone"
                   @mouseout="off.bookCheck = false"
              >
                <div class="card-body px-1 position-relative"
                     @click.self="selectOrRemoveOffer(date.move_date, off.mover_number, data.trucks, off)"
                >
                  <i class="fa fa-thumb-tack pin" v-if="off.is_sent" />
                  <template v-if="!off.openedChangeRate && !off.confirmBooking">
                    <template v-if="!off.bookCheck">
                      <p>
                        <strong>{{ off.mover_number }} Movers</strong><br />
                        <span v-if="parseInt(data.trucks) !== 0">
                          ${{ off.price }}
                        </span>
                        <span v-else>
                          ${{ off.labor }}
                        </span>
                      </p>
                    </template>
                    <template v-else>
                      <div class="w-75">
                        <div class="d-flex justify-content-between">
                          <strong>{{ off.mover_number }} Movers</strong>
                          <span v-if="parseInt(data.trucks) !== 0">
                            ${{ off.price }}
                          </span>
                          <span v-else>
                            ${{ off.labor }}
                          </span>
                        </div>
                        <button type="button"
                                class="btn btn-primary ld-ext-right"
                                @click.self="off.confirmBooking = true"
                        >
                          Book
                        </button>
                      </div>
                    </template>
                    <a @click="openChangeCustomRate(off)" v-if="!off.confirmBooking && data.company.custom_rate" class="text-secondary rate-button">Change rate</a>
                  </template>
                  <template v-else-if="off.openedChangeRate">
                    <strong>{{ off.mover_number }} Movers</strong><br />
                    <div class="d-flex align-items-center w-75">
                      <div class="amount-wrap-small mr-1">
                        <span class="dollar">$</span>
                        <input v-model="off.custom_rate" type="text" class="form-control" />
                      </div>
                      <button class="btn btn-primary btn-sm p-1 m-0" @click="saveChangeCustomRate(off, date.move_date)">Save</button>
                    </div>
                    <error-field :errors="errors" field="custom_rate" />

                    <a @click="closeChangeCustomRate(off)" class="text-secondary rate-button">Cancel</a>
                  </template>
                  <template v-else-if="off.confirmBooking">
                    <div class="w-75">
                      <p class="text-left"><b>Price:</b> ${{ off.custom_rate && off.custom_rate > 0 ? off.custom_rate : off.price }}</p>
                      <p class="text-left"><b>Movers</b> {{ off.mover_number }}</p>
                      <p class="text-left"><b>Date: </b> {{ date.move_date }}</p>
                      <button
                        class="btn btn-success mb-1 mt-1"
                        :disabled="buttonDisabled"
                        @click.self="bookOffer(off, date.move_date)"
                      >
                        Confirm book
                        <div :class="!loadingBookButton ? 'd-none' : ''" class="ld ld-ball ld-flip" />
                      </button>
                    </div>
                    <a @click="off.confirmBooking = false" class="text-secondary rate-button">Cancel</a>
                  </template>
                </div>
              </div>
            </div>
            <div class="add-card-info">Minimum hours: {{ date.minimum_hours }}</div>
            <div class="add-card-info">Deposit: {{ date.deposit }}</div>
          </div>
        </div>

        <div class="card-deck"
             v-else
        >
          <div class="card"
               v-for="(date, indexDate) in offers"
               :key="indexDate + 'e'"
          >
            <div class="mb-2 card-date">
              <div class="mod-icon-dark mod-icon-rates-dark" />
              {{ date.move_date }}
            </div>
            <div class="card-rate-info">
              <div class="row">
                <div class="col available-info border-right text-center p-1">
                  <div class="mod-icon-dark mod-icon-trucks-dark" />
                  {{ date.available_trucks }}
                  <span v-if="date.reserved_trucks" class="text-danger">({{ date.reserved_trucks }})</span>
                </div>
                <div class="col available-info text-center p-1">
                  <div class="mod-icon-dark mod-icon-groups-dark" />
                  {{ date.available_movers }}
                  <span v-if="date.reserved_movers" class="text-danger">({{ date.reserved_movers }})</span>
                </div>
              </div>
              <div v-for="(off, indexOffer) in date.offers"
                   :key="indexOffer + 'r'"
                   class="m-card-offer pointer"
                   :class="{'m-card-offer--selected': off.confirmBooking}"
                   @mouseover="off.bookCheck = true"
                   @mouseout="off.bookCheck = false"
              >
                <div class="card-body px-1 position-relative">
                  <i class="fa fa-thumb-tack pin" v-if="off.is_sent" />
                  <template v-if="!off.openedChangeRate && !off.confirmBooking">
                    <template v-if="!off.bookCheck">
                      <p>
                        <strong>{{ off.mover_number }} Movers</strong><br />
                        <span v-if="parseInt(data.trucks) !== 0">
                          ${{ off.price }}
                        </span>
                        <span v-else>
                          ${{ off.labor }}
                        </span>
                      </p>
                    </template>
                    <template v-else>
                      <div class="w-75">
                        <div class="d-flex justify-content-between">
                          <strong>{{ off.mover_number }} Movers</strong>
                          <span v-if="parseInt(data.trucks) !== 0">
                            ${{ off.price }}
                          </span>
                          <span v-else>
                            ${{ off.labor }}
                          </span>
                        </div>
                        <button type="button"
                                class="btn btn-primary ld-ext-right"
                                @click.self="off.confirmBooking = true"
                        >
                          Book
                        </button>
                      </div>
                    </template>
                    <a @click="openChangeCustomRate(off)" v-if="!off.confirmBooking && data.company.custom_rate" class="text-secondary rate-button">Change rate</a>
                  </template>
                  <template v-else-if="off.openedChangeRate">
                    <strong>{{ off.mover_number }} Movers</strong><br />
                    <div class="d-flex align-items-center w-75">
                      <div class="amount-wrap-small mr-1">
                        <span class="dollar">$</span>
                        <input v-model="off.custom_rate" type="text" class="form-control" />
                      </div>
                      <button class="btn btn-primary btn-sm p-1 m-0" @click="saveChangeCustomRate(off, date.move_date)">Save</button>
                    </div>
                    <error-field :errors="errors" field="custom_rate" />

                    <a @click="closeChangeCustomRate(off)" class="text-secondary rate-button">Cancel</a>
                  </template>
                  <template v-else-if="off.confirmBooking">
                    <div class="w-75">
                      <p class="text-left"><b>Price:</b> ${{ off.custom_rate && off.custom_rate > 0 ? off.custom_rate : off.price }}</p>
                      <p class="text-left"><b>Movers</b> {{ off.mover_number }}</p>
                      <p class="text-left"><b>Date: </b> {{ date.move_date }}</p>
                      <button
                        class="btn btn-success mb-1 mt-1"
                        :disabled="buttonDisabled"
                        @click.self="bookOffer(off, date.move_date)"
                      >
                        Confirm book
                        <div :class="!loadingBookButton ? 'd-none' : ''" class="ld ld-ball ld-flip" />
                      </button>
                    </div>
                    <a @click="off.confirmBooking = false" class="text-secondary rate-button">Cancel</a>
                  </template>
                </div>
              </div>
            </div>
            <div class="add-card-info">Minimum hours: {{ date.minimum_hours }}</div>
            <div class="add-card-info">Deposit: {{ date.deposit }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import store from 'store';
import toastr from 'toastr';
import Errors from '../classes/Errors';
import ErrorField from './ErrorField';
import router from '../router';

export default {
  components: {
    ErrorField,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    bookOfferProp: {
      type: Function,
      default: null,
    },
    getOffersOnLoad: Boolean,
    loadingBookButton: Boolean,
    buttonDisabled: Boolean,
    bookingPhone: {
      type: [Boolean, Number],
      default: null,
    },
  },
  data: () => ({
    offers: [],
    customRated: false,
    customRate: '',
    errors: new Errors(),
    selectedForBooking: [],
    selectedForChangeRate: [],
  }),
  mounted() {
    if (this.getOffersOnLoad) {
      this.getOffers(this.data);
    }
  },
  methods: {
    clearErrors() {
      this.errors.clear();
    },
    openChangeCustomRate(off) {
      off.openedChangeRate = true;
      if (!off.custom_rate) {
        if (parseInt(this.data.trucks, 10) !== 0) {
          off.custom_rate = off.price;
        } else {
          off.custom_rate = off.labor;
        }
      }
    },
    closeChangeCustomRate(off) {
      off.openedChangeRate = false;
      this.getOffers(this.data);
      this.errors.clear();
    },
    saveChangeCustomRate(off, moveDate) {
      const requestData = {
        ref_id: this.data.ref_id,
        move_date: moveDate,
        ...off,
      };

      if (off.offer_id) {
        axios
          .patch(`/offers/custom-rate/${off.offer_id}`, requestData)
          .then(() => {
            toastr.success('Successfully saved custom rate!');
            this.getOffers(this.data);
            this.errors.clear();
          })
          .catch(err => {
            if (err.response.data.error) {
              this.errors.record(err.response.data.error);
            } else {
              toastr.error('Server Error!');
            }
          });
      } else {
        axios
          .post(`/offers/custom-rate/${this.data.ref_id}`, requestData)
          .then(() => {
            toastr.success('Successfully saved custom rate!');
            this.getOffers(this.data);
            this.errors.clear();
          })
          .catch(err => {
            if (err.response.data.error) {
              this.errors.record(err.response.data.error);
            } else {
              toastr.error('Server Error!');
            }
          });
      }
    },
    getOffers(data) {
      const instance = axios.create();
      const movers = data.movers ? data.movers : '';
      const trucks = data.trucks ? data.trucks : '';
      instance.interceptors.response.use(
        response => {
          return response;
        },
        error => {
          const code = error.response.status;
          switch (code) {
            case 401:
              store.remove('dispatchUser');
              store.remove('jwtToken');
              router.push('/login');
              break;
            default:
              break;
          }
          return Promise.reject(error);
        },
      );
      instance
        .get(
          `/companies/${data.company_id}/pricing/offers?ref_id=${data.ref_id}&move_date=${
            data.move_date
          }` +
            `&move_size_id=${data.move_size_id}&mover_number=${encodeURIComponent(movers)}` +
            `&truck_number=${encodeURIComponent(trucks)}&arrival_window_id=${
              data.arrival_window_id
            }`,
        )
        .then(res => {
          res.data.data.offers.forEach(dates => {
            if (dates.offers) {
              dates.offers.forEach(offer => {
                offer.bookCheck = false;
                offer.openedChangeRate = false;
                offer.confirmBooking = false;
                if (offer.offered) {
                  this.$emit('offer-offered');
                }
              });
            }
          });
          this.offers = res.data.data.offers;
          this.$emit('offers-loaded', res.data.data.has_availability);
        })
        .catch(err => {
          if (err.response.data.error.exception) {
            toastr.error(err.response.data.error.exception, '', { timeOut: 0 });
            this.offers = [];
          }
          this.errors.record(err.response.data.error);
        });
    },
    selectOrRemoveOffer(moveDate, moverNumber, truckNumber, offer) {
      if (!offer.offered) {
        this.offers
          .find(dates => dates.move_date === moveDate)
          .offers.filter(offers => offers.mover_number === moverNumber)[0].offered = true;
        axios
          .post(`offers/${this.data.ref_id}`, {
            move_date: moveDate,
            mover_number: moverNumber,
            truck_number: truckNumber,
          })
          .then(() => {
            this.getOffers(this.data);
          })
          .catch(err => {
            this.getOffers(this.data);
            this.$emit('set-offer-error', err);
          });
      } else {
        this.offers
          .find(dates => dates.move_date === moveDate)
          .offers.filter(offers => offers.mover_number === moverNumber)[0].offered = false;
        axios
          .delete(`offers/${offer.offer_id}`)
          .then(() => {
            this.getOffers(this.data);
          })
          .catch(err => {
            this.getOffers(this.data);
            this.errors.record(err.response.data.error);
          });
      }
    },
    bookOffer(offer, moveDate) {
      let pricePerHour = 0;
      if (offer.custom_rate && offer.custom_rate > 0) {
        pricePerHour = offer.custom_rate;
      } else {
        if (parseInt(this.data.trucks, 10) === 0) {
          pricePerHour = offer.labor;
        }
        pricePerHour = offer.price;
      }

      if (offer.offer_id) this.data.offer_id = offer.offer_id;
      this.bookOfferProp({
        ...this.data,
        ref_id: this.data.ref_id,
        customer_id: this.data.customer.id,
        deposit_value: this.data.company.deposit_value,
        minimum_hours: this.data.company.minimum_hours,
        move_date: moveDate,
        movers: offer.mover_number,
        price_per_hour: pricePerHour,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pin {
  top: 8px;
  right: 9px;
  position: absolute;
  transform: rotate(35deg);
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/Offer.vue